import { ContentCard, IconButton, MenuButton } from "@narmi/design_system";
import React from "react";
import styles from "./PromptList.module.css";

function PromptListComponent({ children }: React.PropsWithChildren) {
  return <ol className={styles.PromptList}>{children}</ol>;
}

function PromptListCardItem({
  title,
  description,
  linkText,
  onEdit,
  onDelete,
}: {
  title: string;
  description: string;
  linkText?: string;
  onEdit: () => void;
  onDelete: () => void;
}) {
  return (
    <li className={styles.PromptListCardItem}>
      <div className={styles.Content}>
        <div className="margin--bottom--m fontWeight--bold">{title}</div>
        <div>
          <span className="fontWeight--semibold">Title:</span> {title}
        </div>
        <div className="margin--top--xxs">
          <span className="fontWeight--semibold">Description:</span> {description}
        </div>
        {linkText && (
          <div className="margin--top--xxs">
            <span className="fontWeight--semibold">Link text:</span> {linkText}
          </div>
        )}
      </div>
      <MenuButton
        label="Actions"
        trigger={<IconButton kind="plain" label="Edit" name="more-vertical" />}
      >
        <MenuButton.Item label="Edit step" onSelect={onEdit} />
        <MenuButton.Item label="Delete step" onSelect={onDelete} />
      </MenuButton>
    </li>
  );
}

function PromptListItem({
  title,
  description,
  linkText,
  statusTag,
}: {
  title: string;
  description: string;
  linkText?: string;
  statusTag?: React.ReactNode;
}) {
  return (
    <li className={styles.PromptListItem}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Pushes content and status to opposite sides
          alignItems: "center",
          width: "100%",
        }}
      >
        <div className={styles.Content}>
          <div className="margin--bottom--xxs fontWeight--semibold">{title}</div>
          <div className={`fontSize--s fontColor--secondary ${styles.PreserveWhitespace}`}>
            {description}
            {linkText ? `  |  ${linkText}` : ""}
          </div>
        </div>
        {statusTag && <div className="prompt-list-item__status">{statusTag}</div>}
      </div>
    </li>
  );
}

function PromptListAddCardItem({ onClick }: { onClick: () => void }) {
  return (
    <ContentCard kind="button" onClick={onClick} paddingSize="none">
      <div className={styles.PromptListAddCardItem}>
        <div className={styles.PromptListAddCardItemIcon}>
          <span className="narmi-icon-plus" />
        </div>
        <div className="fontWeight--bold">Add new step</div>
      </div>
    </ContentCard>
  );
}

PromptListComponent.CardItem = PromptListCardItem;
PromptListComponent.Item = PromptListItem;
PromptListComponent.AddCardItem = PromptListAddCardItem;

export const PromptList = PromptListComponent;
